module.exports = __webpack_public_path__ + "img/westervelt-logo.9b8a9e73.jpg";